<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'carall',
      getListUrl: 'driverec',
      breadcrumb: [
        { name: "财务管理", path: `/finance/initialPayment` },
        { name: "预支款管理", path: `/finance/initialPayment` },
        { name: "费用明细" },
      ],
      searchDateOptions: [
        { ...this.ctrls.ZhuangHuoRiQi, },
        { ...this.ctrls.XieHuoRiQi, },
      ],
      formCtrl: [
        {
          label: "加油方式",
          keyName: "gsid",
          placeholder: "请选择加油方式",
          type: "select",
          options: [],
        },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 140 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "predict_loading_date", label: "装货日期", minwidth: 120 },
        { keyName: "predict_unloading_date", label: "卸货日期", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 140 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 140 },
        { keyName: "freight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ orderid }) => {
            this.$router.push(
              `/finance/initialFeedetails?id=${orderid}&mode=view`
            );
          },
        },
      ],
      baseParams: ['license'],
    };
  },
  methods: {
    setOptions({ gasstation, dayauth }) {
      this.formCtrl.map(v => {
        if (v.keyName === 'gsid') {
          this.setCtrlOption(v, gasstation, 'gasname')
        }
      })
      const arr = []
      const arr1 = []
      dayauth.map(v => {
        const o = {
          keyName: v.enname,
          label: v.authname,
          align: 'right',
          className: 'pr30',
          width: 100,
        }
        if (['里程工资',].includes(v.authname)) {
          arr1.push(o)
        } else {
          arr.push(o)
        }
      })
      this.cols.push(...arr)
      this.cols.push(...arr1)
      this.cols.push(
        { keyName: "doil", label: "现金加油", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "moneydoil", label: "油卡加油", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "gsid", label: "加油方式", minwidth: 140 },
        { keyName: "total", label: "费用合计", align: 'right', className: 'pr30', minwidth: 120 },
      )
      this.doLayout()
      this.getTotalProperty = [
        'freight',
        'infreight',
        ...arr.map(v => v.keyName),
        ...arr1.map(v => v.keyName),
        'doil', 'moneydoil', 'total',
      ]
      this.$forceUpdate()
      // console.log({ ...this.formInline })
    },
  },
  created() {
    const { user_group_id } = this.user
    if (user_group_id == 1) {
      this.btns[0] = {
        ...this.editBtn,
        cb: ({ orderid }) => {
          this.$router.push(
            `/finance/initialFeedetails?id=${orderid}&mode=edit`
          );
        },
      }
    }
  },
  mounted() {
    this.getOptions()
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
